import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';
import { stacked } from 'app/shared/styles/_spacing';
import { zindex } from 'app/shared/styles/_zindex';

// Components
import ButtonBase from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';

export const Header = styled.header`
  ${stacked._2x};

  @media (min-width: 768px) {
    padding-left: 16px;
    padding-top: 16px;
    padding-right: 16px;
  }
`;
export const MasterTitle = styled.h1`
  ${font.md};
  color: ${colors['$hpx-blue-600']};
  font-weight: bold;
`;

export const MainPagingText = styled.p`
  ${font.sm};
  color: ${colors['$hpx-grey-600']};
  font-weight: bold;
  ${stacked._1x};
`;

export const SecondaryPagingText = styled.span`
  ${font.sm};
  color: ${colors['$hpx-grey-600']};
  font-weight: normal;
`;

export const ScreenReaderOnly = styled.h2`
  position: absolute;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export const ButtonSection = styled.section`
  display: flex;
  justify-content: space-between;
  position: relative;
`;

export const TransparentOverlay = styled.aside`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${zindex['$z-index-step-over']};
  background: transparent;
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: 195px;
  left: 16px;
  width: 176px;
  margin-top: 4px;
  color: ${colors['$hpx-blue-600']};
  cursor: pointer;
  background-color: ${colors['$hpx-white']};
  border-radius: 4px;
  border: solid 1px ${colors['$hpx-grey-500']};
  z-index: ${zindex['$z-index-parent']};
`;

export const DropdownListItem = styled.li`
  ${font.sm};
  width: 100%;
  border-bottom: 1px solid ${colors['$hpx-grey-100']};
  padding: 8px 16px;
`;

export const AlertsButton = styled(ButtonBase)`
  width: 118px;
  position: relative;
  color: ${colors['$hpx-white']};
  background-color: ${colors['$hpx-teal-500']};
  font-weight: bold;
  white-space: nowrap;
`;

export const SortWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  color: ${colors['$hpx-blue-600']};
`;

export const SortLabel = styled.span`
  ${font.sm};
  color: ${colors['$hpx-blue-600']};
  white-space: nowrap;
`;

export const HiddenSelect = styled.select`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
`;

export const ButtonGroupRight = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: auto;
`;

export const MobileOnly = styled.div`
  display: contents;

  @media (min-width: 768px) {
    display: none;
  }
`;
